<style lang="stylus" scoped>
    .listorder
        /deep/.pcstyleModal-header
            .pcstyleModal-header-text
                font-size 14px !important
        /deep/.pcstyleModal-content
            padding 0 !important
        .listorder-content
            padding 16px 24px 24px 24px
            .drag-area
                position relative
                display flex
                flex-wrap wrap
                column-gap 12px
                row-gap 8px
                overflow hidden
                .drag-area-item
                    display flex
                    align-items center
                    column-gap 4px
                    height 26px
                    padding 4px 8px
                    border-radius 4px
                    background #F2F4F9
                    font-size 14px
                    color #222
                    cursor pointer
                    user-select none
            .footer
                margin-top 24px
                width 100%
                display flex
                justify-content space-between
                .footer-tips
                    color #00000080
                    font-size 12px
                    line-height 28px
                .btn-box
                    display flex
                    column-gap 16px
                    .btn
                        blueBtn()
                    .gray
                        background #EBEDF1
                        color #000
                        &:hover
                            background #ddd
</style>

<template>
    <EDModal class="listorder" ref="modal">
        <div class="listorder-content">
            <vuedraggable class="drag-area" v-model="tempList" v-bind="{ scroll: true, animation: 300 }">
                <div class="drag-area-item" v-for="(item, index) in tempList" :key="index">
                    <span>{{ index + 1 }}.</span>
                    <span>{{ lang == "en" ? item.class.name : item.class["name_" + lang] || "-" }}</span>
                </div>
            </vuedraggable>

            <div class="footer">
                <p class="footer-tips">{{ $t("tips") }}</p>
                <div class="btn-box">
                    <div class="btn blue" @click="confirm">{{ $t("globalConfirm") }}</div>
                    <div class="btn gray" @click="closeModal">{{ $t("globalCancel") }}</div>
                </div>
            </div>
        </div>
    </EDModal>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import vuedraggable from "vuedraggable";

    @Component({
        components: {
            vuedraggable,
        },
    })
    export default class ListOrder extends Vue {
        @Prop()
        list;

        tempList = [];

        // @Watch("list", {immediate: true})
        // setLocalList() {
        //     this.tempList = JSON.parse(JSON.stringify(this.list))
        // }

        closeModal() {
            this.$emit("closeModal");
            this.sensors.track("sortingPopupSave", {
                Catalogues: "RecommendedTemplate",
                action: "cancel",
                sorting: this.tempList.map((item) => item.class.name).join(","),
            });
        }
        submitChange() {
            this.$emit("changeList", this.tempList);
        }
        confirm() {
            this.submitChange();
            this.$emit("closeModal");
            this.sensors.track("sortingPopupSave", {
                Catalogues: "RecommendedTemplate",
                action: "save",
                sorting: this.tempList.map((item) => item.class.name).join(","),
            });
        }
        created() {
            this.tempList = JSON.parse(JSON.stringify(this.list));
        }
        mounted() {
            let dom = this.$refs.modal as any;
            dom.show({
                width: 890,
                title: this.$t("title"),
                closeEvent: () => {
                    this.closeModal();
                },
            });
        }
    }
</script>
<i18n>
{
    "zh": {
        "title": "设置展示顺序",
        "tips": "你可以任意拖动卡片调整位置"
    },
    "en": {
        "title": "Set display order",
        "tips": "You can drag the label to adjust its position"
    },
    "fr": {
        "title": "Définir l'ordre d'affichage",
        "tips": "Faites glisser les onglets pour redéfinir l'ordre d'affichage."
    },
    "de": {
        "title": "Anzeigereihenfolge festlegen",
        "tips": "Registerkarten ziehen, um die Reihenfolge neu anzuordnen."
    },
    "jp": {
        "title": "表示順序を設定",
        "tips": "タブをドラッグして、表示順序を変更できます。"
    },
    "es": {
        "title": "Definir orden de visualización",
        "tips": "Arrastra las pestañas para cambiar el orden de visualización."
    },
    "pt": {
        "title": "Defina a ordem de exibição",
        "tips": "Arraste as guias para reorganizar a ordem de exibição."
    },
    "it": {
        "title": "Imposta ordine di visualizzazione",
        "tips": "Trascina le schede per riorganizzare l'ordine di visualizzazione."
    },
    "tw": {
        "title": "設定顯示順序",
        "tips": "拖曳標籤以重新排列顯示順序。"
    },
    "kr": {
        "title": "표시 순서 설정",
        "tips": "탭을 드래그하여 표시 순서를 다시 정렬합니다."
    }
}
</i18n>
